import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import {
  FaArrowRight,
  FaExternalLinkAlt,
  FaCode,
  FaWallet,
  FaCheck,
  FaQuoteLeft,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaUniversity,
  FaStore,
  FaShoppingCart,
  FaLandmark,
  FaBriefcase,
} from "react-icons/fa";

import Header from "../Templete/Header";
import Footer from "../Templete/Footer";
import "./Home.css";

const serviceCategories = [
  {
    title: "Technology & Digital Solutions",
    description:
      "Build the websites, applications, and connected systems your business needs.",
    icon: FaCode,
    href: "/technology-digital-solutions",
    services: [
      "Software Development",
      "Mobile App Development",
      "Website Design & Development",
      "UI/UX & Graphics Design",
      "SEO Services",
      "Technology Service Provider (TSP)",
    ],
  },
  {
    title: "Payments & E-Governance",
    description:
      "Connect business operations with payment and everyday digital service workflows.",
    icon: FaWallet,
    href: "/payments-e-governance",
    services: [
      "E-Governance Services",
      "Bill Payment Service",
      "Banking Business Correspondent Service",
      "Payment Services",
    ],
  },
];

const industries = [
  ["Fintech & Payments", "fintech", FaWallet],
  ["Banking & Finance", "banking-finance", FaUniversity],
  ["Retail & Distribution", "retail", FaStore],
  ["E-Commerce", "e-commerce", FaShoppingCart],
  ["E-Governance", "e-governance", FaLandmark],
  ["Business Services", "business-services", FaBriefcase],
];

const process = [
  [
    "Understand",
    "We discuss your business, users, existing systems, and priorities.",
  ],
  [
    "Design",
    "We define the scope, map important journeys, and plan the solution.",
  ],
  [
    "Develop",
    "We build the application and validate its important functionality.",
  ],
  [
    "Deliver",
    "We prepare the release and agree maintenance and support requirements.",
  ],
];

// Testimonials retained from the content you supplied.
const testimonials = [
  {
    name: "Sarah M",
    role: "CEO of Global Ventures",
    quote:
      "Working with Formax IT was a game-changer for our business. Their innovative solutions and attention to detail helped us create a website that truly stands out. The team's ability to understand our vision and turn it into reality was impressive. We’ve seen a significant increase in user engagement and overall traffic since the new site launched.",
  },
  {
    name: "Kartik S",
    role: "Director of IPAY",
    quote:
      "The team at Formax provided exceptional customer service from start to finish. They were always available to answer our questions and made the entire process seamless. Their expertise in web development is unmatched, and we couldn't be happier with the end result.",
  },
  {
    name: "Riju Dutta",
    role: "Head Business Development",
    quote:
      "Formax exceeded our expectations in every way. They are reliable, professional, and extremely knowledgeable about the latest web development trends. The project was delivered on time and within budget, and the final product was beyond what we had envisioned.",
  },
  {
    name: "Naren N",
    role: "Founder of Nagar Pay",
    quote:
      "Collaborating with Formax IT was a seamless experience. They took the time to understand our brand and objectives, and the communication throughout the project was excellent. The final website is not only visually appealing but also highly functional. We look forward to working with them again in the future.",
  },
];

const Home = () => {
  useEffect(() => {
    document.title =
      "Formax IT Solutions | Software, Digital Services & Payment Technology";
  }, []);

  return (
    <>
      <Header />

      <main className="fit-home">
        {/* Modern home hero */}
        <section className="fit-home__hero fit-home__hero--modern">
          <div className="fit-home__container fit-home__hero-grid">
            <div className="fit-home__hero-copy">
              <span className="fit-home__hero-badge">
                <span aria-hidden="true" />
                YOUR TECHNOLOGY PARTNER SINCE 2018
              </span>

              <h1>
                Digital solutions.
                <br />
                Connected services.
                <span>Built for your business.</span>
              </h1>

              <p>
                From software and mobile applications to payment technology and
                e-governance services, we help you build, connect, and simplify
                your digital operations.
              </p>

              <div className="fit-home__actions">
                <Link to="/contact-us" className="fit-home__button">
                  Talk to our team
                  <FaArrowRight aria-hidden="true" />
                </Link>

                <a href="#home-services" className="fit-home__hero-explore">
                  Explore our services
                  <FaArrowRight aria-hidden="true" />
                </a>
              </div>

              <div className="fit-home__hero-facts">
                <div>
                  <strong>Since 2018</strong>
                  <span>Building digital solutions</span>
                </div>

                <div>
                  <strong>Web & Mobile</strong>
                  <span>Connected applications</span>
                </div>

                <div>
                  <strong>Business First</strong>
                  <span>Practical technology</span>
                </div>
              </div>
            </div>

            <div className="fit-home__hero-visual fit-home__service-visual">
              <div className="fit-home__visual-orbit" aria-hidden="true" />

              <div className="fit-home__hero-art">
                <img
                  src="/images/formax-hero.png"
                  alt="Business professional holding a tablet"
                  width="1024"
                  height="1536"
                  fetchPriority="high"
                />
              </div>

              <ul
                className="fit-home__visual-labels"
                aria-label="Our areas of expertise"
              >
                <li className="fit-home__visual-label fit-home__visual-label--one">
                  <FaCode aria-hidden="true" />
                  Software Development
                </li>

                <li className="fit-home__visual-label fit-home__visual-label--two">
                  <FaShoppingCart aria-hidden="true" />
                  Websites & Apps
                </li>

                <li className="fit-home__visual-label fit-home__visual-label--three">
                  <FaWallet aria-hidden="true" />
                  Payment Technology
                </li>

                <li className="fit-home__visual-label fit-home__visual-label--four">
                  <FaLandmark aria-hidden="true" />
                  E-Governance
                </li>
              </ul>

              <div className="fit-home__hero-visual-note">
                <span className="fit-home__hero-note-icon">
                  <FaCheck aria-hidden="true" />
                </span>
                <div>
                  <strong>One connected approach</strong>
                  <span>Design · Development · Integration</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Capability strip */}
        <div className="fit-home__capability-strip">
          <ul className="fit-home__container">
            {[
              "Software Development",
              "Mobile Applications",
              "Digital Services",
              "Payment Technology",
            ].map((item) => (
              <li key={item}>
                <FaCheck aria-hidden="true" />
                {item}
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <section
          id="home-services"
          className="fit-home__section"
          aria-labelledby="home-services-title"
        >
          <div className="fit-home__container">
            <div className="fit-home__heading">
              <span className="fit-home__eyebrow">WHAT WE DO</span>
              <h2 id="home-services-title">
                Two areas of expertise.
                <br />
                One connected approach.
              </h2>
              <p>
                Choose the capabilities you need to build your digital presence,
                improve operations, or connect business services.
              </p>
            </div>

            <div className="fit-home__services">
              {serviceCategories.map((category) => {
                const Icon = category.icon;

                return (
                  <article
                    className="fit-home__service-card"
                    key={category.title}
                  >
                    <span className="fit-home__icon">
                      <Icon aria-hidden="true" />
                    </span>
                    <h3>{category.title}</h3>
                    <p>{category.description}</p>

                    <ul className="fit-home__check-list">
                      {category.services.map((service) => (
                        <li key={service}>
                          <FaCheck aria-hidden="true" />
                          <span>{service}</span>
                        </li>
                      ))}
                    </ul>

                    <Link to={category.href} className="fit-home__text-link">
                      Explore this category
                      <FaArrowRight aria-hidden="true" />
                    </Link>
                  </article>
                );
              })}
            </div>
          </div>
        </section>

        {/* Company introduction */}
        <section className="fit-home__section fit-home__section--soft">
          <div className="fit-home__container fit-home__about-grid">
            <div className="fit-home__company-panel">
              <div className="fit-home__logo-panel">
                <img
                  src="/images/logo.png"
                  alt="Formax IT Solutions"
                  width="210"
                  height="72"
                  loading="lazy"
                />
              </div>

              <h3>Technology with a practical purpose.</h3>
              <p>
                We connect development expertise with the operational needs of
                businesses and digital service platforms.
              </p>

              <dl>
                <div>
                  <dt>Founded</dt>
                  <dd>2018</dd>
                </div>
                <div>
                  <dt>Location</dt>
                  <dd>Kolkata, West Bengal</dd>
                </div>
              </dl>
            </div>

            <div>
              <span className="fit-home__eyebrow">ABOUT FORMAX IT</span>
              <h2>Built around the way your business works.</h2>
              <p className="fit-home__body-copy">
                Formax IT Solutions Private Limited brings together software
                development, design, digital services, and payment technology.
              </p>
              <p className="fit-home__body-copy">
                We start with your requirements and consider the complete
                journey: how people use the application, how systems connect,
                and how your team manages everyday operations.
              </p>

              <div className="fit-home__principles">
                <div>
                  <strong>Clear requirements</strong>
                  <p>A defined scope grounded in your business needs.</p>
                </div>
                <div>
                  <strong>Thoughtful implementation</strong>
                  <p>Practical interfaces and connected workflows.</p>
                </div>
              </div>

              <Link to="/about-us" className="fit-home__text-link">
                More about our company
                <FaArrowRight aria-hidden="true" />
              </Link>
            </div>
          </div>
        </section>

        {/* Formax Pay */}
        <section
          className="fit-home__section fit-home__section--dark"
          aria-labelledby="home-platform-title"
        >
          <div className="fit-home__container fit-home__platform-grid">
            <div>
              <span className="fit-home__eyebrow">OUR PLATFORM</span>
              <h2 id="home-platform-title">
                Formax Pay.
                <br />
                Connecting payment technology.
              </h2>
              <p>
                Through Formax Pay, we are building API infrastructure and
                payment orchestration capabilities for business partners.
              </p>
              <p>
                Our focus brings application development, service integrations,
                and operational workflows together.
              </p>

              <a
                href="https://formaxpay.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="fit-home__button"
              >
                Explore Formax Pay
                <FaExternalLinkAlt aria-hidden="true" />
                <span className="fit-home__sr-only">(opens in a new tab)</span>
              </a>
            </div>

            <div className="fit-home__platform-features">
              {[
                [
                  "Connected integrations",
                  "Bring payment and business services into application workflows.",
                ],
                [
                  "Transaction visibility",
                  "Consider status updates, reporting, and operational follow-up.",
                ],
                [
                  "Partner-focused infrastructure",
                  "Develop capabilities around integration and business requirements.",
                ],
              ].map(([title, description]) => (
                <article key={title}>
                  <FaCheck aria-hidden="true" />
                  <div>
                    <h3>{title}</h3>
                    <p>{description}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* Industries */}
        <section className="fit-home__section">
          <div className="fit-home__container">
            <div className="fit-home__heading-row">
              <div className="fit-home__heading">
                <span className="fit-home__eyebrow">INDUSTRY SOLUTIONS</span>
                <h2>Different industries. Practical solutions.</h2>
                <p>
                  Explore how our capabilities can support the workflows and
                  customer journeys in your sector.
                </p>
              </div>

              <Link to="/industries" className="fit-home__text-link">
                All industries
                <FaArrowRight aria-hidden="true" />
              </Link>
            </div>

            <div className="fit-home__industry-grid">
              {industries.map(([title, id, Icon]) => (
                <Link to={`/industries#${id}`} key={id}>
                  <span className="fit-home__icon">
                    <Icon aria-hidden="true" />
                  </span>
                  <span>{title}</span>
                  <FaArrowRight aria-hidden="true" />
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Approach */}
        <section className="fit-home__section fit-home__section--soft">
          <div className="fit-home__container">
            <div className="fit-home__heading">
              <span className="fit-home__eyebrow">HOW WE WORK</span>
              <h2>A clear path from requirements to release.</h2>
              <p>
                A focused process helps keep development aligned with the goals
                of your business.
              </p>
            </div>

            <ol className="fit-home__process">
              {process.map(([title, description], index) => (
                <li key={title}>
                  <span aria-hidden="true">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <h3>{title}</h3>
                  <p>{description}</p>
                </li>
              ))}
            </ol>
          </div>
        </section>

        {/* Testimonials */}
        <section
          className="fit-home__section"
          aria-labelledby="home-testimonials-title"
        >
          <div className="fit-home__container">
            <div className="fit-home__heading">
              <span className="fit-home__eyebrow">CLIENT EXPERIENCES</span>
              <h2 id="home-testimonials-title">In our clients’ words.</h2>
              <p>
                Feedback on collaboration, communication, and the solutions we
                deliver.
              </p>
            </div>

            <div className="fit-home__testimonials">
              {testimonials.map((testimonial) => (
                <figure
                  className="fit-home__testimonial"
                  key={testimonial.name}
                >
                  <FaQuoteLeft aria-hidden="true" />

                  <blockquote>
                    <p>{testimonial.quote}</p>
                  </blockquote>

                  <figcaption>
                    <span className="fit-home__avatar" aria-hidden="true">
                      {testimonial.name
                        .split(" ")
                        .slice(0, 2)
                        .map((part) => part.charAt(0))
                        .join("")}
                    </span>
                    <span>
                      <strong>{testimonial.name}</strong>
                      <span>{testimonial.role}</span>
                    </span>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </section>

        {/* Contact */}
        <section
          className="fit-home__section fit-home__section--soft"
          aria-labelledby="home-contact-title"
        >
          <div className="fit-home__container">
            <div className="fit-home__contact">
              <div>
                <span className="fit-home__eyebrow">LET’S CONNECT</span>
                <h2 id="home-contact-title">
                  Your next idea starts with a conversation.
                </h2>
                <p>
                  Tell us about the application, integration, or service you
                  need. We’ll help outline the next steps.
                </p>
                <Link to="/contact-us" className="fit-home__button">
                  Contact our team
                  <FaArrowRight aria-hidden="true" />
                </Link>
              </div>

              <address>
                <div>
                  <FaPhoneAlt aria-hidden="true" />
                  <span>
                    <strong>Call us</strong>
                    <a href="tel:+919836114520">+91 98361 14520</a>
                  </span>
                </div>

                <div>
                  <FaEnvelope aria-hidden="true" />
                  <span>
                    <strong>Email us</strong>
                    <a href="mailto:info@formaxit.com">info@formaxit.com</a>
                  </span>
                </div>

                <div>
                  <FaMapMarkerAlt aria-hidden="true" />
                  <span>
                    <strong>Visit our office</strong>
                    Ground Floor, 16, Mochpole, Near Junior School, Nabapally,
                    Barasat, Kolkata – 700126, West Bengal, India
                  </span>
                </div>
              </address>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default Home;
